import React from 'react';

interface DropdownProps {
	children: React.ReactNode[]
}

function DropdownToggle({ children, ...props }: { children: React.ReactNode } & React.ButtonHTMLAttributes<HTMLButtonElement>) {
	return (
		<button
			aria-expanded="false"
			{...props}
			type={props.type ?? 'button'}
			className={props.className ?? 'btn btn-secondary dropdown-toggle'}
			data-bs-toggle="dropdown"
		>
			{children}
		</button>
	);
}

function DropdownMenu(props: { children: React.ReactNode } & React.HTMLProps<HTMLUListElement>) {
	return (
		<ul className={`${props.className ?? ''} dropdown-menu`}>
			{props.children}
		</ul>
	);
}

function Dropdown(props: DropdownProps) {
	return (
		<div className="dropdown">
			{props.children}
		</div>
	);
}

Dropdown.Toggle = DropdownToggle;
Dropdown.Menu = DropdownMenu;

Dropdown.displayName = 'Dropdown';

export default Dropdown;
